
<div v-show="afficherNavigation">
  <template v-if="barreNavigation == 'compte'">
    <!-- Point d'entrée de la barre navigation PCU -->
    <div v-if="afficherPCU" v-show="enteteChargee" id="barreNavigation"></div>
    <nav v-if="barreNavigation == 'compte'" :class="{ 'position-relative': afficherPCU }">
      <div class="nav-conteneur d-flex align-items-center nav-hauteur" :class="theme">
        <div
          v-if="afficherLienRetour && !cacherLienPrecedent"
          class="box col en-tete-pr-0 en-tete-pl-1"
        >
          <a data-precedent="precedent" class="lien-retour" @click="$router.go(-1)">
            <svg-icon :icon-name="iconeLienRetour" fill="transparent" />
            {{ $t('precedent') }}
          </a>
        </div>
        <div
          class="col en-tete-px-1"
          :class="afficherLienRetour ? 'text-center' : 'text-md-left'"
        >
          <WithRoot :show="!mixinEnvironnement_inAppMobile">
            <a
              v-if="themeLogoNav !== 'invisible'"
              :href="jel_nettoyerLienExterne($t('hyperlien.portailLotoQuebec'))"
            >
              <svg-icon
                class="logo-lq"
                :class="isSmallerScreen ? theme : themeLogoNav"
                :icon-name="logoLQ"
              />
              <label class="sr-only">{{ $t('retourAccueil') }}</label>
            </a>
          </WithRoot>
        </div>

        <!-- Afficher les routes uniquement en développment -->
        <div v-if="mixinEnvironnement_isDeveloppement && actualRoutes" class="col-0 en-tete-px-0">
          <router-link
            v-if="!isSessionEstOuverte()"
            v-slot="{ href, navigate }"
            to="/connexion"
            custom
          >
            <a :href="href" class="text-secondary" title="Connexion" @click="navigate"
              >&#x2714;</a
            >
          </router-link>
          <router-link
            v-if="isSessionEstOuverte()"
            v-slot="{ href, navigate }"
            to="/compte/deconnexion"
            custom
          >
            <a :href="href" class="text-secondary" title="Déconnexion" @click="navigate">
              &#x2718;
            </a>
          </router-link>
        </div>

        <!-- Afficher les routes uniquement en développment -->
        <div v-if="mixinEnvironnement_isDeveloppement && actualRoutes" class="col-4 en-tete-px-0">
          <b-form-group class="my-1" label-sr-only :label="$t('page')" label-for="routeOption">
            <b-form-select
              id="routeOption"
              v-model="routeOptionSelected"
              name="routeOption"
              @change="changerRoute"
            >
              <b-form-select-option
                v-for="item in actualRoutes"
                :key="item['@id']"
                :value="item['@path'] != undefined ? item['@path'].replace('/jel', '') : ''"
              >
                {{ item.title }}
              </b-form-select-option>
            </b-form-select>
          </b-form-group>
        </div>

        <div v-if="mixinEnvironnement_isDeveloppement" class="col-2 languages">
          <b-form-group class="my-1" label-sr-only :label="$t('langue')" label-for="langueOption">
            <b-form-select
              id="langueOption"
              v-model="currentLanguage"
              name="langueOption"
              class="form-control"
              @change="clickLanguage(currentLanguage)"
            >
              <b-form-select-option
                v-for="language in languages"
                :key="language"
                :value="language"
              >
                {{ language }}
              </b-form-select-option>
            </b-form-select>
          </b-form-group>
        </div>

        <div
          v-if="!aide.isAideActif && mixinEnvironnement_isNavigateurSupporte"
          class="col en-tete-pl-0 pr-1 d-flex justify-content-end"
        >
          <div
            v-if="themeAideNav == 'themeLienSuperieurDroit'"
            class="justify-content-end lien-superieur-droit"
          >
            <span v-if="libSuperieurDroit1">{{ libSuperieurDroit1 }}&nbsp;</span>
            <a :href="lienSuperieurDroit" class="lien-aide">{{ libSuperieurDroit2 }}</a>
          </div>
          <b-link
            v-else
            :href="lienBoutonAide"
            :target="targetBoutonAide"
            data-aide="aide"
            class="btnVide lien-aide row mx-0 en-tete-px-0 align-items-center d-flex flex-row flex-nowrap"
            :class="isSmallerScreen ? theme : themeAideNav"
            @click="toggleAide()"
          >
            {{ $t('aide') }}
            <span class="d-none d-sm-block ml-2 icone-aide">?</span>
          </b-link>
        </div>
      </div>
    </nav>
  </template>
  <template v-else>
    <!-- Point d'entrée de la barre navigation PCU -->
    <div id="barreNavigation"></div>
  </template>
</div>
